import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-12" }
const _hoisted_4 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_5 = { class: "panel-container show" }
const _hoisted_6 = { class: "panel-content" }
const _hoisted_7 = {
  key: 0,
  class: "gtablecell"
}
const _hoisted_8 = {
  key: 1,
  class: "gtablecell"
}
const _hoisted_9 = {
  key: 2,
  class: "gtablecell"
}
const _hoisted_10 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", { class: "subheader col-6" }, [
        _createElementVNode("h1", { class: "subheader-title" }, "拠点目標マスタ一覧")
      ]),
      _createElementVNode("div", { class: "subheader-block ml-auto demo" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_vue_good_table, {
                mode: "remote",
                onPageChange: _ctx.onPageChange,
                onSortChange: _ctx.onSortChange,
                columns: _ctx.columns,
                rows: _ctx.delegate.items,
                "sort-options": {
                  enabled: false,
                },
                "pagination-options": {
                  enabled: false,
                  // perPageDropdownEnabled: false,
                  // jumpFirstOrLast: false,
                  // nextLabel: '次へ',
                  // prevLabel: '前へ',
                  // mode: 'pages',
                  // ofLabel: '/',
                  // pageLabel: '',
                },
                totalRows: _ctx.delegate.pager.maxcount
              }, {
                "table-row": _withCtx((props) => [
                  (props.column.field == 'c_goal_earnings_sum')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(props.formattedRow[props.column.field].toLocaleString(
                        "ja-JP"
                      )), 1))
                    : (props.column.field == 'c_goal_gross_sum')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(props.formattedRow[props.column.field].toLocaleString(
                        "ja-JP"
                      )), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(props.formattedRow[props.column.field]), 1))
                ]),
                _: 1
              }, 8, ["onPageChange", "onSortChange", "columns", "rows", "totalRows"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => _cache[4] || (_cache[4] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}